import React from 'react';
import Icon from '../../Icon/Icon';
import { SupportedIconName } from '../../../shared/icons';
import BodyText from '../../Typography/BodyText/BodyText';
import styles from './OverflowMenuItem.module.scss';
import Flex from '../../Flex/Flex';
import Gutter from '../../Gutter/Gutter';
import { CommonProps } from '../../Element/Element';

export type OverflowMenuProps = {
  /** Item label */
  label: string;
  /** Item icon name */
  iconName?: SupportedIconName;
  /** Item variant, one of disabled, destructive or active  */
  variant?: 'disabled' | 'destructive' | 'active';
  onClick: () => void;
} & CommonProps<'div'>;

export const OverflowMenuItem: React.FunctionComponent<OverflowMenuProps> = ({
  label,
  iconName,
  onClick,
  variant = 'active',
  ...props
}) => {
  const onKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' && onClick && variant !== 'disabled') {
      onClick();
      event.preventDefault();
    }
  };

  return (
    <Flex
      {...props}
      onClick={variant !== 'disabled' ? onClick : undefined}
      centeredVertically
      className={[
        'overflow-menu-item-test',
        styles.overflowMenuItem,
        { [styles.overflowMenuItem__disabled]: variant === 'disabled' },
      ]}
      onKeyDown={onKeyDown}
      tabIndex={onClick && variant !== 'disabled' ? 0 : undefined}
      clickableAppearance={!!onClick}
      padding={{ vertical: 'xs', horizontal: 'sm' }}
      backgroundColor="white"
      backgroundHoverColor="gray200"
      hoverColor={variant === 'destructive' ? 'red600' : 'black'}
    >
      {iconName && (
        <>
          <Icon name={iconName} size="sm" />

          <Gutter size="xs" />
        </>
      )}

      <BodyText tagName="span">{label}</BodyText>
    </Flex>
  );
};

export default OverflowMenuItem;
